<template>
  <div class="home2025">
    <HeroSection />
    <StatsBar />
    <PlatformSection />
    <SolutionsSection />
    <QuoteDivider />
    <CasesSection />
    <TencentSection />
    <HonorsSection />
    <PartnersSection />
    <ContactSection />
    <AiConsultingSection />
    <NewsSection />
    <!-- CTA -->
    <section class="cta-section">
      <div class="h25-container">
        <h2>准备好成为创势生态伙伴了吗？</h2>
        <p>获取伙伴合作白皮书，了解详细合作权益与分润方案</p>
        <span class="btn-white" @click="goAnchor('contact')">立即咨询合作</span>
      </div>
    </section>
    <!-- Footer -->
    <footer class="h25-footer">
      <div class="h25-container">
        <p class="ft-name">深圳市<span class="ft-accent">创势互联</span>科技有限公司</p>
        <p style="margin:4px 0">让技术更好地服务社会</p>
        <p>做伙伴最可靠的 AI 后端技术中台</p>
        <p style="margin-top:6px">© 2026 创势互联 版权所有</p>
      </div>
    </footer>
    <!-- 右下角浮标 -->
    <div class="float-btns">
      <div class="float-btn" @click="scrollTo('top')" title="回到顶部">▲</div>
      <div class="float-btn" @click="scrollTo('bottom')" title="直达底部">▼</div>
    </div>
    <NewsDetailOverlay ref="newsDetail" />
  </div>
</template>

<script>
import HeroSection from './sections/HeroSection.vue'
import StatsBar from './sections/StatsBar.vue'
import PlatformSection from './sections/PlatformSection.vue'
import SolutionsSection from './sections/SolutionsSection.vue'
import QuoteDivider from './sections/QuoteDivider.vue'
import CasesSection from './sections/CasesSection.vue'
import TencentSection from './sections/TencentSection.vue'
import HonorsSection from './sections/HonorsSection.vue'
import PartnersSection from './sections/PartnersSection.vue'
import ContactSection from './sections/ContactSection.vue'
import AiConsultingSection from './sections/AiConsultingSection.vue'
import NewsSection from './sections/NewsSection.vue'
import NewsDetailOverlay from './sections/NewsDetailOverlay.vue'

export default {
  name: 'Home2025',
  components: {
    HeroSection, StatsBar, PlatformSection, SolutionsSection,
    QuoteDivider, CasesSection, TencentSection, HonorsSection,
    PartnersSection, ContactSection, AiConsultingSection, NewsSection, NewsDetailOverlay
  },
  provide() {
    return { showNewsDetail: this.showNewsDetail, goAnchor: this.goAnchor }
  },
  methods: {
    showNewsDetail(news) {
      this.$refs.newsDetail.open(news)
    },
    scrollTo(dir) {
      window.scrollTo({ top: dir==='top'?0:document.body.scrollHeight, behavior:'smooth' })
    },
    goAnchor(id){
      const el=document.getElementById(id)
      if(el) el.scrollIntoView({behavior:'smooth'})
    }
  },
  mounted(){
    const h=this.$route.hash
    if(h) this.$nextTick(()=>{const el=document.getElementById(h.slice(1));if(el)el.scrollIntoView({behavior:'smooth'})})
  }
}
</script>

<style>
@import './styles.css';
</style>
